<template>
  <div>
    <b-modal
      v-if="system_update && system_update.status == 1"
      title="ATUALIZAÇÃO"
      id="system-update"
      no-close-on-backdrop
      hide-footer
    >
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center">
            <p class="worksansr">{{ system_update.message }}</p>
            <h6 class="text-fourteen">
              DATA DA ATUALIZAÇÃO: {{ formatDate(system_update.date, false) }}
            </h6>
          </div>
          <div v-if="system_update.list" class="col-md-12">
            <h6 class="text-center">FUNCIONALIDADES NOVAS:</h6>
            <ol>
              <li
                class="bottom-border p-2 mb-2"
                v-for="(topic, key) in JSON.parse(system_update.list)"
                :key="key"
              >
                {{ topic.message }}
              </li>
            </ol>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { formatDate } from "../../lib/format";

export default {
  name: "SystemUpdate",
  data() {
    return {
      system_update: undefined,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatDate,
    retrieve() {
      let system_update = sessionStorage.getItem("system_update");
      if (system_update) {
        this.system_update = JSON.parse(system_update);
      }
    },
  },
};
</script>
